module.exports = __webpack_public_path__ + "img/75761.040d592a.svg";